module.exports = __webpack_public_path__ + "resources/img/img-acra-point-01-m-jp.21f905ff6f02d4e51eb443a6c6c1fd8d.png";